class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onHoverMediaChange = this.onHoverMediaChange.bind(this);

    this.bindHoverEvents();
    if (this.hoverMediaQuery.addEventListener) {
      this.hoverMediaQuery.addEventListener('change', this.onHoverMediaChange);
    } else if (this.hoverMediaQuery.addListener) {
      this.hoverMediaQuery.addListener(this.onHoverMediaChange);
    }
  }

  bindHoverEvents() {
    if (!this.hoverMediaQuery.matches) return;
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  unbindHoverEvents() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    clearTimeout(this.hoverCloseTimeout);
  }

  onHoverMediaChange() {
    this.unbindHoverEvents();
    this.bindHoverEvents();
  }

  getAnimatedElements() {
    if (!this.content) return [];

    return [
      this.content,
      ...this.content.querySelectorAll(
        '.mega-menu__category, .content__main-item, .mega-menu__list > li, .mega-menu__cta-wrapper, .mega-menu__traits'
      ),
    ];
  }

  restartOpenAnimation() {
    const elements = this.getAnimatedElements();

    elements.forEach((element) => {
      element.style.animation = 'none';
    });

    // Force the browser to drop the previous animation state before re-applying
    void this.offsetHeight;

    requestAnimationFrame(() => {
      elements.forEach((element) => {
        element.style.animation = '';
      });
    });
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      clearTimeout(menu.hoverCloseTimeout);
      if (menu.mainDetailsToggle?.hasAttribute('open')) {
        menu.close();
      }
    });
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimeout);

    const alreadyOpen = this.mainDetailsToggle.hasAttribute('open');
    this.closeOtherMenus();

    if (alreadyOpen) return;

    this.openWithAnimation();
  }

  openWithAnimation() {
    this.isOpeningWithAnimation = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    this.restartOpenAnimation();
    this.isOpeningWithAnimation = false;
  }

  onMouseLeave() {
    this.hoverCloseTimeout = setTimeout(() => this.close(), 200);
  }

  close() {
    clearTimeout(this.hoverCloseTimeout);
    super.close();

    // Clear inline animation overrides so the next open can play cleanly
    this.getAnimatedElements().forEach((element) => {
      element.style.animation = '';
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Click / keyboard open — hover already restarts the animation itself
    if (this.mainDetailsToggle.open && !this.isOpeningWithAnimation) {
      this.restartOpenAnimation();
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
